export const apiRoutes = {
  base: import.meta.env.DEV ? '/bioflux' : '/api',
  auth: {
    base: '/auth',
    cognito: '/cognito',
    register: '/register',
  },
  consumption: {
    base: '/consumption',
    chart: '/chart',
    export: '/export',
    update: '/update',
  },
  masters: {
    base: '/masters',
  },
  moeveActions: {
    base: '/actions',
    changeStatus: '/change-status',
  },
  company: {
    base: '/company',
  },
  plants: {
    base: '/plants',
  },
  users: {
    base: '/user',
  },
};
